export enum BannerStatusEnum {
  ACTIVE = 1,
  NOT_ACTIVE = 2,
}
